import '@app/lib/yup'
import { MantineProvider, ReactQueryProvider, SugarProvider } from '@app/providers'
import { type DehydratedState } from '@tanstack/react-query'
import { type AppType } from 'next/app'
import Head from 'next/head'
import { type Session } from 'next-auth'
import { SessionProvider } from 'next-auth/react'

type AppProps = {
  dehydratedState: DehydratedState
  session?: Session
}

const App: AppType<AppProps> = ({ Component, pageProps: { dehydratedState, session, ...pageProps } }) => (
  <>
    <Head>
      <link
        rel='preconnect'
        href='https://fonts.gstatic.com'
      />
      <link
        rel='icon'
        type='image/png'
        href='/favicon-96x96.png'
        sizes='96x96'
      />
      <link
        rel='icon'
        type='image/svg+xml'
        href='/favicon.svg'
      />
      <link
        rel='shortcut icon'
        href='/favicon.ico'
      />
      <link
        rel='apple-touch-icon'
        sizes='180x180'
        href='/apple-touch-icon.png'
      />
      <link
        rel='manifest'
        href='/site.webmanifest'
      />
    </Head>
    <SessionProvider
      // Re-fetch session every 15 minutes
      refetchInterval={15 * 60}
      // Re-fetches session when window is focused
      refetchOnWindowFocus={true}
      session={session}
    >
      <ReactQueryProvider dehydratedState={dehydratedState}>
        {/* MantineProvider wraps SugarProvider, not the other way round:
            SugarProvider renders the unsaved-changes dialog itself, and nested
            the other way that dialog would fall outside the theme and render
            with Mantine's defaults instead of the brand's. MantineProvider
            reads nothing from SugarContext, so only the order changes. */}
        <MantineProvider>
          <SugarProvider>
            <Component {...pageProps} />
          </SugarProvider>
        </MantineProvider>
      </ReactQueryProvider>
    </SessionProvider>
  </>
)

// noinspection JSUnusedGlobalSymbols
export default App
